import type { DummyFoods } from './dummyFoods'

export const salmon: DummyFoods = {
  Salmon: {
    Farmed: ['Salmon (Farmed)'],
    Wild: ['Salmon (Wild)'],
  },
}
